export default "/_next/static/images/img3-ba867d0ee40b155b8a813275e5eedea5.png";